module.exports = __webpack_public_path__ + "img/bca.f33edf04.png";